import { Box, Button, FormControl, MenuItem, Select, Stack, Typography } from "@mui/material";
import ApiIcon from '@mui/icons-material/Api';
import { DatePicker, LocalizationProvider, PickersActionBar } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { format, parse } from "date-fns";
import { ru } from "date-fns/locale";
import { useDispatch, useSelector } from "react-redux";
import { setParams } from "store/report/reportSlice";
import { useRef, useState } from "react";

const dateFormat = "dd MMMM yyyy";
const referenceDate = new Date(1970, 0, 1, 0, 0, 0);

const ReportParams = (props) => {
  
  const reportParams = props.params;
  const { params } = useSelector(state => state.report);
  const dispatch = useDispatch();
  const [openDate, setOpenDate] = useState({start: false, end: false});
  
  const renderComboItems = (store) => 
    props[store].map(el =>  <MenuItem key={el.id} value={el.id}>{el.name}</MenuItem>);


  const renderDaterange = (item, key) => {
    return (
      <Stack direction="row" key={key} mb={1} spacing={2} sx={{justifyContent: 'center', alignItems: 'center', width: '100%'}}>
        <Stack direction='row' sx={{ position: "relative", flex: 1, minWidth: 0}}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}> 
            <DatePicker 
              format={params[item.nameStart] ? "dd MMMM yyyy": ' '}
              label={item.labelStart}
              value={ params[item.nameStart] && (typeof params[item.nameStart] === 'string') ? parse(params[item.nameStart], dateFormat, referenceDate) : null }
              slots={{
                actionBar: PickersActionBar
              }}
              slotProps={{
                actionBar: {
                  actions: ['clear']
                },
                textField: {
                  size: 'small',
                  readOnly: true,
                  InputLabelProps: { shrink: true },
                  onMouseDown: (e) => {
                    if (e.target.closest('.MuiIconButton-root')) return;

                    e.preventDefault();
                    setOpenDate((prev) => ({...prev, start: true}));    
                  },
                  sx: {
                    flexGrow: 1,
                    '& input': {
                      pointerEvents: 'none'
                    }
                  }
                },
                openPickerButton: {
                  onClick: () => {
                    setOpenDate((prev) => ({...prev, start: true}));    
                  }
                }
              }}
              disableFuture
              open={openDate.start}
              onClose={() => setOpenDate((prev) => ({...prev, start: false}))}
              onChange={(dateObject, context) => {
                setOpenDate((prev) => ({...prev, start: false}));
                dispatch(setParams({name: item.nameStart, value: (dateObject ? format(dateObject, dateFormat) : null)}))
              }} 
              sx={{flexGrow: 1}}
            />
          </LocalizationProvider>
          {!params[item.nameStart] && (
            <Box
              sx={{
                position: "absolute",
                left: 14,
                top: "50%",
                transform: "translateY(-50%)",
                pointerEvents: "none",
              }}
            >
              С начала
            </Box>
          )}
        </Stack>
        <Typography variant="body1">-</Typography>
        <Stack sx={{flex: 1, minWidth: 0}}>
          <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ru}>
          <DatePicker
            format="dd MMMM yyyy"
            label={item.labelEnd}
            slotProps={{
              field: {
                size: 'small'
              }
            }}
            value={ params[item.nameEnd] ? parse(params[item.nameEnd], dateFormat, referenceDate) : (new Date()) }
            disableFuture
            onChange={(dateObject, context) => dispatch(setParams({name: item.nameEnd, value: format(dateObject, dateFormat)}))}
            sx={{flex: '1'}}/>
        </LocalizationProvider>    
        </Stack>
        
        
      </Stack>

    );
  };

  const renderCombo = (item, key) => {
    return (
      <Stack direction="row" key={key} spacing={1} sx={{justifyContent: 'center', alignItems: 'center'}}>
        <Typography>{item.label}</Typography>
        <FormControl sx={{flex: '1'}}>
          <Select
            value={params[item.name] ?? ''}
            displayEmpty
            size="small"
            onChange={(e) => dispatch(setParams({name:item.name, value: e.target.value}))}
            renderValue={(selected) => { 
              if(selected.length === 0) {
                return <span style={{ color: 'rgba(0,0,0,0.6)'}}>Выберите значение...</span>;
              }
              const option =  props[item.store].find(el => el.id === selected);
              return option ? option.name : selected;
            }}
          >
            {renderComboItems(item?.store)}
          </Select>
        </FormControl>
      </Stack>
    );
  };

  const renderParams = () => 
    reportParams.map((el, index)=> {
      switch(el.type) {
        case 'daterange': return renderDaterange(el, index);
        case 'combo': return renderCombo(el, index);
        default: return null;
      }
    });
  

  return (
    <Stack spacing={1} mb={3} sx={{width: 450}}>
      {renderParams()}
    </Stack>
  );
};

export default ReportParams;